import React from 'react';
import { getColorSwatchSegments } from '../../utils/colorUtils';

const CableColorRect = ({
  color,
  width = '20px',
  height = '20px',
  borderRadius = '4px',
  border = '1px solid #ddd',
  className = ''
}) => {
  const segments = getColorSwatchSegments(color);
  const isStriped = segments.length > 1;

  if (isStriped) {
    // Pattern giallo/verde per cavi di terra
    return (
      <div
        className={`overflow-hidden ${className}`}
        style={{
          width,
          height,
          borderRadius,
          border,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {segments.map((segmentColor) => (
          <div
            key={segmentColor}
            style={{
              width: '100%',
              height: `${100 / segments.length}%`,
              backgroundColor: segmentColor
            }}
          />
        ))}
      </div>
    );
  } else {
    // Colore solido per tutti gli altri cavi
    const solidColor = segments[0];
    return (
      <div
        className={className}
        style={{
          width,
          height,
          borderRadius,
          border,
          backgroundColor: solidColor
        }}
      />
    );
  }
};

export default CableColorRect;
